import type { ColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import { BASE_MAPS_COLUMN_ID } from '~/map/layered/layering.repository';
import {
  type SpreadsheetColumnsToFetchNumberResponse, type SpreadsheetDataBulkRequestGetter, type SpreadsheetDataBulkResponse,
} from '~/spreadsheet/spreadsheet.repository';
import { DataType } from '~/store/spreadsheetData/spreadsheetData.state';

export const MIN_NUMERIC_AND_EMPTY_PERCENTAGE = 85;
export const MIN_PERCENTAGE_NUMERIC = 50;

export const isColumnNumeric = ({ numericAndEmptyPercent, numericPercent, columnId }: {
  numericAndEmptyPercent: number;
  numericPercent: number;
  columnId: ColumnId;
}) => (
  columnId !== BASE_MAPS_COLUMN_ID
  && (
    (numericAndEmptyPercent >= MIN_NUMERIC_AND_EMPTY_PERCENTAGE && numericPercent > 0)
  || numericPercent >= MIN_PERCENTAGE_NUMERIC
  )
);

export const isColumnNumericFromNumberResponse = (columnId: ColumnId, column: SpreadsheetColumnsToFetchNumberResponse) => (
  isColumnNumeric({ numericAndEmptyPercent: column.numeric_and_empty_percent, numericPercent: column.numeric_percent, columnId })
);

export const createGetSpreadsheetBulkDataNumericParams = (mapId: number, spreadsheetId: number, columnIds: string[]): SpreadsheetDataBulkRequestGetter => {
  const columnsToFetch = columnIds.reduce((result, curValue) => {
    return { ...result, [curValue]: {} };
  }, {});

  return {
    map_id: mapId,
    spreadsheet_id: spreadsheetId,
    exclude_basic_data: true,
    exclude_row_data: true,
    columns_to_fetch: {
      [DataType.NUMBER]: columnsToFetch,
    },
  };
};

export const getValidNumericColumnIds = (data: SpreadsheetDataBulkResponse): string[] => {
  const numberColumnsData = data.result.columns_to_fetch?.number;
  if (!numberColumnsData) {
    return [];
  }
  return Object.entries(numberColumnsData)
    .filter(([columnId, columnData]) => isColumnNumericFromNumberResponse(columnId, columnData))
    .map(([columnId]) => columnId);
};
